import * as React from 'react';
import ExpendituresCore from '../AfrCore/ExpendituresCore';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';

const ExpendituresA = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <ExpendituresCore userRole={isAdminUser ? "ADMIN" : "USER"} />
        </React.Fragment>
    );
}

export default ExpendituresA;